<div class="p-6 flex flex-col gap-4">
  <app-table
    [config]="historyTableConfig"
    [data]="historyTableData"
    [(selectedElements)]="selectedElements"
  >
  </app-table>

  @if (selectedElements.length > 0) {
    <app-tabs>
      @for (tab of detailTabs; track tab.title) {
        <app-tab [title]="tab.title | translate">
          <div class="table-wrapper relative shadow-sm text-sm">
            <div class="border border-gray-200 dark:border-dark-border rounded-md overflow-hidden">
              <table class="w-full rounded-md table-fixed border-collapse overflow-hidden bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border">
                <tbody>
                  @for (col of tab.columns; track col.title) {
                    <tr class="border-b border-gray-200 dark:border-dark-border odd:bg-gray-50 dark:odd:bg-dark-hover">
                      <th class="w-64 text-left px-2 py-2 font-normal border-r border-gray-200 dark:border-dark-border dark:text-dark-text">
                        {{ col.title | translate }}
                      </th>
                      @for (element of selectedElements; track element; let i = $index) {
                        <td
                          class="text-primary dark:text-dark-text py-2 px-2 border-slate-200 truncate"
                          [ngClass]="{ 'bg-yellow-100': hasValueChanged(col.key, i) }"
                        >
                          <app-table-cell
                            [config]="col"
                            [data]="element"
                          ></app-table-cell>
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </app-tab>
      }
    </app-tabs>
  }
</div>
